/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_AssigneeInputs */

const en_group_assignee = /** @type {(inputs: Group_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

const de_group_assignee = /** @type {(inputs: Group_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuständig`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Group_AssigneeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const group_assignee = /** @type {((inputs?: Group_AssigneeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_AssigneeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_group_assignee(inputs)
	return en_group_assignee(inputs)
});